import { marker as _ } from '@jsverse/transloco-keys-manager/marker';

/**
 * Static navigation tree for the default layout.
 *
 * This intentionally mirrors the app-facing route groups and avoids any API dependency.
 * Labels use translation keys that will be resolved in the template.
 */
export const DEFAULT_LAYOUT_NAVIGATION = [
  {
    label: _('layout.default.navigation.items.dashboard'),
    icon: 'pi pi-palette',
    routerLink: '/dashboard',
  },
  {
    label: _('layout.default.navigation.items.trucks'),
    icon: 'pi pi-truck',
    routerLink: '/trucks',
  },
  {
    label: _('layout.default.navigation.items.warehouses'),
    icon: 'pi pi-home',
    routerLink: '/warehouses',
  },
  {
    label: _('layout.default.navigation.items.operations'),
    icon: 'pi pi-hammer',
    items: [
      {
        label: _('layout.default.navigation.items.orders'),
        icon: 'pi pi-file-plus',
        routerLink: '/orders',
      },
      {
        label: _('layout.default.navigation.items.instructions'),
        icon: 'pi pi-file-check',
        routerLink: '/operations/instructions',
      },
    ],
  },
];
